<div class="min-h-[94px] w-full rounded-lg border border-[#E9EAEE] p-4" [ngClass]="className">
  <p class="text-sm text-aux-gray-dark-100">{{ topText }}</p>
  <ng-content select="[topText]"></ng-content>
  <p class="text-2xl font-bold text-aux-gray-darkest">{{ middleText }}</p>
  @if (bottomTemplate) {
    <div>
      <ng-container [ngTemplateOutlet]="bottomTemplate"></ng-container>
    </div>
  }
</div>
